import React, { useEffect, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useShowAlert } from "../../../context/AlertContext";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import Messages from "../../../constants/Messages";
import { usePermission } from "../../../context/PermissionContext";
import { useContextApi } from "../../../context/ContextApi";
import { useNetwork } from "../../../context/NetworkContext";
import EditStock from "./EditStock";
import DeleteModal from "../../../constants/DeleteModal";
import StockOut from "./StockOut";
import { BarcodeIcon, BarcodeReaderIcon, BuildingIcon, CalendarIcon, CodeIcon, DeleteIcon, EditIcon, FileIcon, IdCardIcon, RupeeIcon, StockIcon, XIcon } from "../../../constants/Icons";

const ViewStockDetails = ({
  onClose,
  editData,
  onStockEditData,
  closeEditModal,
  handleStockpdate,
  isStockEditModalOpen,
  setStockEditModalOpen,
  setStockOutModalOpen,isStockOutModalOpen,closeStockOutModal,handleStockTrash
}) => {
  
  const [isStockOutData, setStockOutData] = useState("");
  const showAlert = useShowAlert();
  const [isEditStockData,setISEditStockData]=useState()
  const { isUser } = useAuth();
  const {
    permission,
    hasPermission,
  } = usePermission();
  const [data, setData] = useState(editData);

  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-label-success";
      case "inactive":
        return "bg-label-danger";
      default:
        return "bg-label-secondary";
    }
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const openEditModal = (cItem, cIndex) => {
    if (hasPermission("STOCK", "STOCK:update") || permission === undefined) {
      const isValidDate = (date) => date && !isNaN(new Date(date).getTime());
      setISEditStockData({
        ...cItem,
        mrp: cItem.mrp,
        saleprice: cItem.saleprice,
        discount: cItem.discount,
        baseprice: cItem.baseprice,
        taxamount: cItem.taxamount,
        landingcost: cItem.landingcost,
        manufacturedate: isValidDate(cItem.manufacturedate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem.manufacturedate)),
                "yyyy-MM-dd",
                isUser.timezone
              )
            ).date
          : "",
        expiredate: isValidDate(cItem.expiredate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem.expiredate)),
                "yyyy-MM-dd",
                isUser.timezone
              )
            ).date
          : "",
        cIndex: cIndex,
      });
      setStockEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openDeleteTrashModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:deleteTrash") ||
      permission === undefined
    ) {
      setStockOutModalOpen(true);
      cItem.cIndex = index;
      setStockOutData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  useEffect(() => {
    if (editData) {
      setData(editData);
    }
  }, [editData]);

//   useEffect(() => {
//     if (onStockData) {
//       setStockData(onStockData);
//     }
//   }, [onStockData]);

  const handleUpdateStock = (product) => {
    
    const isValidDate = (date) => date && !isNaN(new Date(date).getTime());
    setData({
        ...product,
        mrp: product.mrp,
        saleprice: product.saleprice,
        discount: product.discount,
        baseprice: product.baseprice,
        taxamount: product.taxamount,
        landingcost: product.landingcost,
        manufacturedate: isValidDate(product.manufacturedate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(product.manufacturedate)),
                "yyyy-MM-dd",
                isUser.timezone
              )
            ).date
          : "",
        expiredate: isValidDate(product.expiredate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(product.expiredate)),
                "yyyy-MM-dd",
                isUser.timezone
              )
            ).date
          : "",
      });
    handleStockpdate(product);
  };

  const handleTrashStock=(updatedData, quantity, remarks)=>{
    setData((prv)=>({
        ...prv,
        stockLeft: prv.stockLeft - quantity,
  }))
    handleStockTrash(updatedData, quantity, remarks)
  }
  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog  modal-xl  modal-dialog-scrollable">
          <div className="modal-content" style={{ minHeight: "500px" }}>
            <div className="modal-header">
              <div className="d-flex align-items-center text-center modal-title pe-3">
                Stock View{" "}
                {/* <div className="text-center ms-2">
                  <span className="badge rounded-pill bg-label-navy">
                    {data?.code}{" "}
                  </span>
                  &nbsp;- {data?.title}
                </div> */}
              </div>
              <div className="d-flex align-items-center fw-bold text-dark mb-0 ms-auto me-2">
                {/* <button
                  type="button"
                  className="btn btn-label-primary shadow-none  me-4 py-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    openEditModal(data);
                  }}
                >
                  <i className="ng ng-ng-edit-icon me-1 "></i>Edit
                </button> */}
                <button
                  type="button"
                  className="btn-close border"
                  onClick={onClose}
                ></button>
              </div>
            </div>
            <div className="modal-body">
              <div className="card shadow-sm border-0 rounded-3 p-3">
                {/* Header with Name + Paylater */}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align=items-center fw-bold text-dark mb-2">
                  <BarcodeReaderIcon iClass={"fs-4 text-dark"}/>{" "}
                    <span className="fs-4 ms-2">{data?.title}</span>
                  </div>

                  {/* Paylater section */}

                  <div className="text-end">
                    <div className="order-actions ">
                      <button
                        type="button"
                        className="btn-label-primary shadow-none me-2"
                        onClick={(e) => {
                          e.stopPropagation();
                          openEditModal(data);
                        }}
                      >
                        <EditIcon/>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Phone */}
                <div className="d-flex ">
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <BarcodeIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">SKU Code:</span>
                    <span className="badge rounded-pill bg-label-navy">
                      {data?.code}
                    </span>
                  </div>
                </div>
                <div className="d-flex ">
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <CodeIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">HSN:</span>
                    {data?.hsnsac ? (
                      <span className="badge rounded-pill bg-label-retro">
                        {data.hsnsac}
                      </span>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="d-flex ">
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <RupeeIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">MRP:</span>
                    <span className="text-dark">
                      ₹{data?.mrp}
                    </span>
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <RupeeIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">Sale Price:</span>
                    <span className="text-dark">
                      ₹
                      {
                        data?.saleprice}
                    </span>
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <FileIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">Tax(%):</span>
                    <span className="badge rounded-pill bg-label-peace">
                      {data?.taxpercentage
                        ? `${data?.taxpercentage}%`
                        : "0%"}
                    </span>
                  </div>
                </div>
                <div className="d-flex ">
                <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <RupeeIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">Discount:</span>
                    <span className="text-dark">
                      ₹
                      {
                        data?.discount}
                    </span>
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <RupeeIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">Base Price:</span>
                    <span className="text-dark">
                      ₹
                      {
                        data?.baseprice}
                    </span>
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <RupeeIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">Tax Amount</span>
                    <span className="text-dark">
                      ₹
                      {
                        data?.taxamount}
                    </span>
                  </div>
                 
                </div>
                <div className="d-flex ">
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <BuildingIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">
                      Landing Cost:
                    </span>
                    <span className="text-dark">
                      ₹
                      
                        {data?.landingcost}
                    </span>
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <CalendarIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">ManufactureDate:</span>
                    {data?.manufacturedate && (
                      <span className="badge bg-label-tea">
                        {
                          data?.manufacturedate
                        }
                      </span>
                    )}
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <CalendarIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">ExpireDate:</span>
                    {data?.expiredate && (
                      <span className="badge bg-label-wood">
                        {data?.expiredate}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex ">
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <StockIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">
                     Stock In:
                    </span>

                    {data?.stockIn ? (
                     <span className="badge bg-label-spring">
                     {data?.stockIn}
                   </span>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <StockIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">
                     Stock Left:
                    </span>

                    {data?.stockLeft ? (
                     <span className="badge bg-label-space">
                     {data?.stockLeft}
                   </span>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div
                    className="mb-2 d-flex align-items-center gap-2"
                    style={{ flexBasis: "28%" }}
                  >
                    <IdCardIcon iClass={"fs-5 text-muted"}/>
                    <span className="fw-semibold text-muted">Status:</span>

                    {data?.status && (
                      <span
                        className={`badge rounded-pill ${getColor(
                            data?.status
                        )}`}
                      >
                        {data?.status.charAt(0).toUpperCase() +
                          data?.status.slice(1).toLowerCase()}
                      </span>
                    )}
                  </div>
                </div>
                <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-label-danger shadow-none"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDeleteTrashModal(data);
                      }}
                    >
                      <DeleteIcon/>
                    </button>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <XIcon iClass={"fs-15"}/> Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      {isStockEditModalOpen && (
        <EditStock
          editData={isEditStockData}
          onClose={closeEditModal}
          onEdit={handleUpdateStock}
        //   isBtnLoading={isLoading}
        />
      )}
      {isStockOutModalOpen && (
        <StockOut
          data={isStockOutData}
          onClose={closeStockOutModal}
          onEdit={handleTrashStock}
        //   isBtnLoading={isBtnLoading}
        />
      )}

    </div>
  );
};

export default ViewStockDetails;
